<template>
<div></div>
</template>

<script>
export default {
  name: "vehicle-spec"
}
</script>

<style scoped>

</style>
